export default __webpack_public_path__ + "static/media/fauna-az-quote.191ea41f.png";